"use strict";

var silent = function silent(fn) {
  return function (arg) {
    try {
      return fn(arg);
    } catch (err) {
      return arg;
    }
  };
};

module.exports = silent;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/functional/silent.js
// module id = 2177
// module chunks = 37